import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IUserOwnTractor } from '../../../../api/user/queries/getUsersOwnTractors';
import { AnimateLoading } from '../../../../components/common/loading/AnimateLoading';
import { SurveyForm } from '../../../../components/common/survey/form/SurveyForm';
import { SurveyInputContainer } from '../../../../components/common/survey/inputs/SurveyInputContainer';
import { SurveyInputHeader } from '../../../../components/common/survey/inputs/SurveyInputHeader';
import { RadioCard } from '../../../../components/common/Radio/RadioCard';
import { MachineApprovalStatus } from '../../../../constants/machine/machine.constant';
import { useGetUsersOwnTractors } from '../../../../hooks/api/user/queries/useGetUsersOwnTractors';
import { useAppDispatch } from '../../../../hooks/store/useStore';
import { userSellTractorSurveySlice } from '../../../../store/userSellTractorSurveySlice';
import { SellTractorSurveyPageWrapper } from '../SellTractorSurveyPageWrapper';

export const SellTractorSurveyOwnTractorListPage = () => {
  const navigate = useNavigate();

  const [selectedUserOwnTractor, setSelectedUserOwnTractor] = useState<IUserOwnTractor>();

  const { data: usersOwnTractors, isLoading: isGetUsersOwnTractorsLoading } = useGetUsersOwnTractors({
    searchParam: { machineApprovalStatus: MachineApprovalStatus.APPROVAL },
  });

  const dispatch = useAppDispatch();
  const userSellTractorSurveyActions = userSellTractorSurveySlice.actions;

  useEffect(() => {
    dispatch(userSellTractorSurveyActions.changeIsSellTractorSurveyStartedProperly(true));
  }, [dispatch, userSellTractorSurveyActions]);

  if (isGetUsersOwnTractorsLoading) {
    return <AnimateLoading />;
  }

  if (usersOwnTractors) {
    return (
      <SellTractorSurveyPageWrapper
        headerTitle={'다음 절차를 위해 선택해주세요'}
        canConfirm={!!selectedUserOwnTractor?.id}
        confirmHandler={() => {
          if (!selectedUserOwnTractor) {
            return;
          }

          dispatch(userSellTractorSurveyActions.changeUserOwnTractorId(selectedUserOwnTractor.id));
          dispatch(
            userSellTractorSurveyActions.changeSellTractorRequiredInputs({
              brand: selectedUserOwnTractor?.brand?.name,
              brandId: selectedUserOwnTractor?.brand?.id,
              model: selectedUserOwnTractor?.machine?.model,
              engineOutputInPs:
                selectedUserOwnTractor.machine.approvalStatus === MachineApprovalStatus.APPROVAL
                  ? selectedUserOwnTractor?.machine.engineOutputInPs
                  : undefined,
              manufacturedYear: selectedUserOwnTractor?.manufacturedYear,
              operationTime: selectedUserOwnTractor?.operationTime,
            }),
          );
          navigate('/survey/progress/sell-tractor/required-input-overview', { replace: true });
        }}
      >
        <SurveyForm padding={'0px 16px'}>
          <SurveyInputHeader inputTitle={'트랙터 선택'} isRequired />

          <SurveyInputContainer gridColumns={1}>
            {usersOwnTractors.map((tractor) => (
              <RadioCard
                key={tractor.id}
                title={tractor.brand?.name}
                label={tractor.machine?.model}
                onClick={() => {
                  setSelectedUserOwnTractor(tractor);
                }}
                isActive={selectedUserOwnTractor?.id === tractor.id}
              />
            ))}
          </SurveyInputContainer>
        </SurveyForm>
      </SellTractorSurveyPageWrapper>
    );
  }

  return <></>;
};
